import { ReactElement } from 'react'
import {
  MailingStaticCampaign,
  ResponseBalances,
  ResponseCampaign,
  ResponseDisplayCPCCampaign,
  ResponseDisplayCPSCCampaign,
  ResponseFeedCPSCCampaign,
  ResponseDisplayVCPMCampaign,
  ResponseGenericCampaign,
  ResponseMailingProspectingCampaign,
  ResponseProspectingCampaign,
  ResponseRetargetingCampaign,
  ResponseStaticMailingCampaign,
  ResponsePushCampaign,
  OutstreamVideoCampaign,
  ProductType,
  GenericCampaignType,
  NewsletterType,
  PublishersDisplayVCPMCampaign,
  ResponseProspecting2Campaign,
  Targeting,
  BudgetModel,
  AttributionWindow,
} from '@ads/front-core/api'
import { ITextInput } from '@ads/front-core/components/Form/TextInput'
import { SortDir } from '@ads/front-core/constants/sort'

export type TCamapign = {
  type: ResponseCampaign['type']
  company: string
  title: string
  description: string
  href: string
  imageUrl?: string
}

export enum ProductFor {
  NONPUBLISHER,
  PUBLISHER,
}

export type Campaign = ResponseRetargetingCampaign &
  ResponseMailingProspectingCampaign &
  ResponseStaticMailingCampaign &
  ResponseProspectingCampaign &
  ResponseDisplayCPCCampaign &
  ResponseDisplayVCPMCampaign &
  MailingStaticCampaign &
  ResponsePushCampaign &
  PublishersDisplayVCPMCampaign &
  ResponseDisplayCPSCCampaign &
  ResponseFeedCPSCCampaign &
  ResponseProspecting2Campaign &
  OutstreamVideoCampaign

export type AllProductTypes = ProductType | GenericCampaignType | NewsletterType

export type CampaignTypeItem = {
  id: string
  type: string
  label: string
  techLabel?: string
  filters: {
    types: Campaign['type'][]
    allowedCreationTypes?: Campaign['allowedCreationTypes']
  }
  availableFor: ProductFor[]
}

export type GenericCampaignTypeItem = {
  id: string
  type: string
  label: string
  techLabel?: string
  filters: {
    types: AllProductTypes[]
  }
  availableFor: ProductFor[]
}

export type MACampaignTypeItem = {
  id: string
  type: string
  label: string
  techLabel?: string
  filters: { types: AllProductTypes[] }
  availableFor: ProductFor[]
}

export type AllCampaignTypeItem =
  | CampaignTypeItem
  | GenericCampaignTypeItem
  | MACampaignTypeItem

export type SortCampaigns = {
  sortBy: string
  sortDir: SortDir
}

export type Balances = ResponseBalances & {
  isLoading: boolean
}

export type CampaignStatus =
  | Campaign['status']
  | ResponseGenericCampaign['status']
  | 'WAITING'
  | 'RESERVATION'

export type TargetingIabCategoriesAttributes = keyof Targeting['iabCategories']['attributes']

export type WarningRunningCampaignField =
  | 'country'
  | 'smartTargeting'
  | 'optimizationMetric'

export type WizardProductDescription = {
  title: string
  description: string
  Icon: React.FC
  wpBooster?: boolean
}

export type WizardParameter = {
  label: string
  value: string | ReactElement
}

export type Product = {
  id: AllProductTypes
  url: string
  budgetModel?: BudgetModel[]
  productDescription?: WizardProductDescription
  parameters: WizardParameter[]
}

export type ProductConfigItem = {
  withDevices: boolean
  type: ITextInput['type']
  rateKeys: ('DEFAULT' | AttributionWindow)[]
}

export type ProductConfig = {
  label: string
  productType: ProductType
} & ProductConfigItem
